import request from '@/utils/request'

const _Prefix = "/businessDistrict"

// 查询商圈信息列表
export function businessDistrictList(query) {
    return request({
        url: _Prefix + '/list',
        method: 'get',
        params: query
    })
}

// 根据商圈ID查询街道和门牌号信息
export function queryStreetByBDId(query) {
    return request({
        url: _Prefix + `/queryStreet/${query}`,
        method: 'get',
    })
}


// 查询商圈信息详细
export function getBusinessDistrict(id) {
    return request({
        url: _Prefix + '/' + id,
        method: 'get'
    })
}

// 新增商圈信息
export function addBusinessDistrict(data) {
    return request({
        url: _Prefix,
        method: 'post',
        data: data
    })
}

// 修改商圈信息
export function updateBusinessDistrict(data) {
    return request({
        url: _Prefix,
        method: 'put',
        data: data
    })
}

// 删除商圈信息
export function delBusinessDistrict(ids) {
    return request({
        url: _Prefix + '/' + ids,
        method: 'delete'
    })
}